import "./About.css";

const About = () => {
  console.log(window.innerHeight);
  return (
    <div className="About">
      <h2>About</h2>
      <p>
        {" "}
        Dynamic Digital Team Leader at Walmart with a proven track record in
        enhancing team productivity and customer satisfaction. Skilled in
        process improvement and team motivation, I empower diverse teams to
        excel. Committed to fostering collaboration and achieving shared goals.
        Experienced with software development, creating efficient and robust
        applications. Utilizes programming languages and debugging tools to
        deliver high-quality code.
      </p>
    </div>
  );
};

export default About;
